module.exports = __webpack_public_path__ + "static/media/unibest-solution-img4.557807c8.png";